import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextoEditorComponent } from './texto-editor/texto-editor.component';
import { TextoEditorCidComponent } from './texto-editor-cid/texto-editor-cid.component';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { MentionModule } from '@syncfusion/ej2-angular-dropdowns';
import { ReactiveFormsModule } from '@angular/forms';
import { TextoEditorPipe } from './texto-editor.pipe';
import { HtmlVisualizadorPipe } from './html-visualizador.pipe';
import { TooltipAllModule } from '@syncfusion/ej2-angular-popups';
import { PesquisaModule } from '../pesquisa/pesquisa.module';



@NgModule({
  declarations: [
    TextoEditorComponent,
    TextoEditorCidComponent,
    TextoEditorPipe,
    HtmlVisualizadorPipe
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RichTextEditorAllModule,
    TooltipAllModule,
    PesquisaModule,
    MentionModule
  ],
  exports: [
    TextoEditorComponent,
    TextoEditorCidComponent,
    TextoEditorPipe,
    HtmlVisualizadorPipe
  ]
})
export class CompartilhadoModule { }
